import Vue from 'vue'
import ApiService from '@/common/api.service'

export const state = {
  /*
   * partnersSelectionSets is a "grouping" of multiple partners that are
   * selected. For example, one might wish to have a "global" set of
   * selected partners that is persistent across all screens or one
   * might want to create a set of selected partners for a particular
   * individual/group of widgets.
   */
  partnerSelectionSets: {}
}

export const getters = {
  /**
   * Returns the full state object
   *
   * @param state Object
   *
   * @return Object
   */
  get (state) {
    return state
  },

  /**
   * Returns the sets of selected partners.
   *
   * @param state Object
   *
   * @return Object
   */
  partnerSelectionSets (state) {
    return state.partnerSelectionSets
  }
}

export const actions = {
  /**
   * Query/find one or more partners.
   *
   * @param context Object
   * @param params  Array of query key's and values
   *
   * @return Promise
   */
  query (context, params) {
    return ApiService
      .get(`partners`, params)
      .then((response) => {
        return response
      })
  }
}

export const mutations = {
  /**
   * Add a map or array of object partners that have been selected within
   * the specified set.
   *
   * @param state    Object
   * @param set      String
   * @param partners Array|Map
   */
  addSelectedPartners (state, { set, partners }) {
    if (!state.partnerSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.partnerSelectionSets, set, {})
    }

    partners.forEach(partner => {
      Vue.set(state.partnerSelectionSets[set], partner.id, partner)
    })
  },

  /**
   * Set a single selected partner, all other selected partners
   * in the set will be cleared.
   *
   * @param state   Object
   * @param set     String
   * @param partner Object
   */
  setSelectedPartner (state, { set, partner }) {
    Vue.set(state.partnerSelectionSets, set, {})
    Vue.set(state.partnerSelectionSets[set], partner.id, partner)
  },

  /**
   * Removes an array of partners from the set's list of selected partners.
   * The array must consist of the id's of the partners that are no
   * longer selected.
   *
   * @param state    Object
   * @param set      String
   * @param partners Array
   */
  removeSelectedPartners (state, { set, partners }) {
    if (state.partnerSelectionSets.hasOwnProperty(set)) {
      partners.forEach(partner => {
        Vue.delete(state.partnerSelectionSets[set], partner.id)
      })
    }
  },

  /**
   * Clears all selected partners.
   *
   * @param state  Object
   */
  clearAllSelectedPartners (state) {
    Vue.set(state, 'partnerSelectionSets', {})
  },

  /**
   * Clears all selected partners within a specified set.
   *
   * @param state  Object
   * @param set      String
   */
  clearSelectedPartners (state, set) {
    if (state.partnerSelectionSets.hasOwnProperty(set)) {
      Vue.set(state.partnerSelectionSets, set, {})
    }
  },

  /**
   * Clears all partners.
   *
   * @param state Object
   */
  purge (state) {
    state.partnerSelectionSets = {}
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}



// WEBPACK FOOTER //
// ./src/store/administration/partners/findPartnersWidgetModule.js